// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  font-weight: 300; }

.wrapper {
  text-align: center; }

.loader {
  position: relative;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  animation: 4500ms linear 0s normal none infinite running;
  animation-name: rotate;
  left: 25px; }

.loader span::after {
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #fff;
  content: "";
  display: block;
  transform-origin: 25px 25px;
  animation-duration: 3000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out; }

@keyframes rotate {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.pip-0::after {
  transform: rotate(0deg);
  animation-name: rotate-0;
  animation-delay: 900ms; }

@keyframes rotate-0 {
  0%,
  20% {
    transform: rotate(0deg); }
  40%,
  60% {
    transform: rotate(180deg); }
  80%,
  100% {
    transform: rotate(360deg); } }

.pip-1::after {
  transform: rotate(20deg);
  animation-name: rotate-1;
  animation-delay: 775ms; }

@keyframes rotate-1 {
  0%,
  20% {
    transform: rotate(20deg); }
  40%,
  60% {
    transform: rotate(200deg); }
  80%,
  100% {
    transform: rotate(380deg); } }

.pip-2::after {
  transform: rotate(40deg);
  animation-name: rotate-2;
  animation-delay: 650ms; }

@keyframes rotate-2 {
  0%,
  20% {
    transform: rotate(40deg); }
  40%,
  60% {
    transform: rotate(220deg); }
  80%,
  100% {
    transform: rotate(400deg); } }

.pip-3::after {
  transform: rotate(60deg);
  animation-name: rotate-3;
  animation-delay: 525ms; }

@keyframes rotate-3 {
  0%,
  20% {
    transform: rotate(60deg); }
  40%,
  60% {
    transform: rotate(240deg); }
  80%,
  100% {
    transform: rotate(420deg); } }

.pip-4::after {
  transform: rotate(80deg);
  animation-name: rotate-4;
  animation-delay: 400ms; }

@keyframes rotate-4 {
  0%,
  20% {
    transform: rotate(80deg); }
  40%,
  60% {
    transform: rotate(260deg); }
  80%,
  100% {
    transform: rotate(440deg); } }

.pip-5::after {
  transform: rotate(100deg);
  animation-name: rotate-5;
  animation-delay: 275ms; }

@keyframes rotate-5 {
  0%,
  20% {
    transform: rotate(100deg); }
  40%,
  60% {
    transform: rotate(280deg); }
  80%,
  100% {
    transform: rotate(460deg); } }

@keyframes opacity {
  from {
    opacity: 1; }
  to {
    opacity: 0; } }
`, "",{"version":3,"sources":["webpack://./src/components/loading/loading.scss"],"names":[],"mappings":"AAMA;EACC,gBAAgB,EAAA;;AAGjB;EACC,kBAAkB,EAAA;;AAGnB;EACC,kBAAkB;EAClB,WAbiB;EAcjB,YAdiB;EAejB,kBAAkB;EAClB,wDAAiE;EACjE,sBAAsB;EACtB,UAAsB,EAAA;;AAEvB;EACC,kBAAkB;EAClB,UArBa;EAsBb,WAtBa;EAuBb,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,2BAA+C;EAC/C,0BA9BgB;EA+BhB,mCAAmC;EACnC,sCAAsC,EAAA;;AAGvC;EACC;IACC,uBAAuB,EAAA;EAExB;IACC,yBAAyB,EAAA,EAAA;;AAU1B;EAEE,uBAAkC;EAClC,wBAAgB;EAChB,sBAAiB,EAAA;;AAInB;EACC;;IAEC,uBAAkC,EAAA;EAEnC;;IAEC,yBAAgC,EAAA;EAEjC;;IAEC,yBAAmC,EAAA,EAAA;;AAnBrC;EAEE,wBAAkC;EAClC,wBAAgB;EAChB,sBAAiB,EAAA;;AAInB;EACC;;IAEC,wBAAkC,EAAA;EAEnC;;IAEC,yBAAgC,EAAA;EAEjC;;IAEC,yBAAmC,EAAA,EAAA;;AAnBrC;EAEE,wBAAkC;EAClC,wBAAgB;EAChB,sBAAiB,EAAA;;AAInB;EACC;;IAEC,wBAAkC,EAAA;EAEnC;;IAEC,yBAAgC,EAAA;EAEjC;;IAEC,yBAAmC,EAAA,EAAA;;AAnBrC;EAEE,wBAAkC;EAClC,wBAAgB;EAChB,sBAAiB,EAAA;;AAInB;EACC;;IAEC,wBAAkC,EAAA;EAEnC;;IAEC,yBAAgC,EAAA;EAEjC;;IAEC,yBAAmC,EAAA,EAAA;;AAnBrC;EAEE,wBAAkC;EAClC,wBAAgB;EAChB,sBAAiB,EAAA;;AAInB;EACC;;IAEC,wBAAkC,EAAA;EAEnC;;IAEC,yBAAgC,EAAA;EAEjC;;IAEC,yBAAmC,EAAA,EAAA;;AAnBrC;EAEE,yBAAkC;EAClC,wBAAgB;EAChB,sBAAiB,EAAA;;AAInB;EACC;;IAEC,yBAAkC,EAAA;EAEnC;;IAEC,yBAAgC,EAAA;EAEjC;;IAEC,yBAAmC,EAAA,EAAA;;AAKtC;EACC;IACC,UAAU,EAAA;EAEX;IACC,UAAU,EAAA,EAAA","sourcesContent":["// https://codepen.io/Mobius1/pen/aNVyzp\n\n$duration: 3000ms;\n$loader-size: 50px;\n$pip-size: 8px;\n\nh1 {\n\tfont-weight: 300;\n}\n\n.wrapper {\n\ttext-align: center;\n}\n\n.loader {\n\tposition: relative;\n\twidth: $loader-size;\n\theight: $loader-size;\n\tborder-radius: 50%;\n\tanimation: $duration * 1.5 linear 0s normal none infinite running;\n\tanimation-name: rotate;\n\tleft: $loader-size / 2;\n}\n.loader span::after {\n\tposition: absolute;\n\twidth: $pip-size;\n\theight: $pip-size;\n\tborder-radius: 50%;\n\tbackground-color: #fff;\n\tcontent: \"\";\n\tdisplay: block;\n\ttransform-origin: $loader-size/2 $loader-size/2;\n\tanimation-duration: $duration;\n\tanimation-iteration-count: infinite;\n\tanimation-timing-function: ease-in-out;\n}\n\n@keyframes rotate {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n@for $i from 0 through 5 {\n\t$start: $i * 20;\n\t$delay: 900 - ($i * 125);\n\t$mid: 180 + $start;\n\t$finish: 360 + $start;\n\n\t.pip-#{$i} {\n\t\t&::after {\n\t\t\ttransform: rotate(#{$start}deg);\n\t\t\tanimation-name: rotate-#{$i};\n\t\t\tanimation-delay: #{$delay}ms;\n\t\t}\n\t}\n\n\t@keyframes rotate-#{$i} {\n\t\t0%,\n\t\t20% {\n\t\t\ttransform: rotate(#{$start}deg);\n\t\t}\n\t\t40%,\n\t\t60% {\n\t\t\ttransform: rotate(#{$mid}deg);\n\t\t}\n\t\t80%,\n\t\t100% {\n\t\t\ttransform: rotate(#{$finish}deg);\n\t\t}\n\t}\n}\n\n@keyframes opacity {\n\tfrom {\n\t\topacity: 1;\n\t}\n\tto {\n\t\topacity: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
